import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import ShareItems from 'src/app.feature/academy/cbt.detail/component/ShareItems';
import CbtButtonGroup from 'app.feature/academy/cbt.detail/component/CbtButtonGroup';
import ArrowRight from 'src/app.feature/academy/component/icon/arrow-right-small.svg';
import ExamIconSvg from 'src/app.feature/academy/component/icon/exam-icon.svg';
import ViewIconSvg from 'src/app.feature/academy/component/icon/eye-icon-regular.svg';
import { useCurrentUser } from 'src/app.hooks/useCurrentUser';
import { useRecoilValue } from 'recoil';
import { projectConfigState } from 'recoil/Academy/projectConfigState';
import CbtDescriptionMobile from 'app.feature/academy/cbt.detail/component/CbtDescriptionMobile';
import Link from 'next/link';
import { TExamsInfo } from 'app.type/examsInfo';
import ExamApi from 'lib/api/exam';
import { useQuery } from '@tanstack/react-query';
import CbtBuyButton from './CbtBuyButton';
import qs from 'qs';

const CbtDescription = () => {
  const router = useRouter();
  const examIdx = Number(router.query.examIdx);
  const { user } = useCurrentUser();
  const { handleLoginRedirect, logo } = useRecoilValue(projectConfigState);

  const {
    data: examInfo = null,
    isLoading,
    isError,
  } = useQuery<TExamsInfo>({
    queryKey: [`/apiV2/exams/${examIdx}`],
    queryFn: () => ExamApi.getExamInfo(examIdx),
  });

  const onClickModeOption = () => {
    if (!user) {
      router.push(handleLoginRedirect(window.location.href));
      return;
    }
    const randomUrl = `/cbt/select/random/${examIdx}`;
    if ((examInfo?.examSubjectMulties || [])?.length > 0) {
      router.push(randomUrl, undefined, { scroll: false });
    } else {
      alert('랜덤 모의고사를 지원하지 않는 시험입니다.');
    }
  };

  const examType = (examInfo?.examTypes || []).filter((type: any) => !type?.parentId);
  const href = '/' + qs.stringify({ examTypeIds: examType.at(0)?.id }, { addQueryPrefix: true });

  return (
    <StyledWrapper>
      <CbtDescriptionMobile examInfo={examInfo} />
      <div className="cbt-detail-wrapper">
        <p className="category-box">
          <Link href={href}>{examType.at(0)?.name}</Link>
          <ArrowRight />
          {examInfo?.examName}
        </p>
        <figure className="detail-box">
          {examInfo?.examUrl ? (
            <div className="cbt-image">
              <img src={examInfo.examUrl} width={150} height={150} alt={examInfo.examName} />
            </div>
          ) : (
            <div className="cbt-image">
              <img src={logo} width={150} height={150} alt={examInfo?.examName} />
            </div>
          )}
          <figcaption className="cbt-description-wrapper">
            <h1 className="title"> {examInfo?.examName} </h1>
            <div className="cbt-description-info-wrapper">
              <span className="cbt-description-info">
                <ExamIconSvg />
                문제 수: {Number(examInfo?.problemCount ?? 0).toLocaleString()}
              </span>
              <span className="cbt-description-info">
                <ViewIconSvg />
                조회수: {Number(examInfo?.viewCount ?? 0).toLocaleString()}
              </span>
            </div>
            <div className="cbt-description-box">
              <div
                className="cbt-description"
                dangerouslySetInnerHTML={{
                  __html: examInfo?.description || '',
                }}
              ></div>
            </div>
            <ShareItems examInfo={examInfo} descripttion={examInfo?.description} />
            <CbtButtonGroup
              // onClickModeOption={on ClickModeOption}
              examIdx={examIdx}
            />
          </figcaption>
        </figure>
      </div>
      <StyledMobileBuyBtn>
        <CbtBuyButton examIdx={examIdx} />
      </StyledMobileBuyBtn>
    </StyledWrapper>
  );
};

export default CbtDescription;

const StyledWrapper = styled.div`
  margin-bottom: 60px;

  .category-box {
    margin: 30px 0 45px;

    p {
      font-size: 18px;
      color: #333;
      vertical-align: middle;
    }
    svg {
      margin: 0 12px;
    }
  }

  .cbt-detail-wrapper {
    @media ${({ theme }) => theme.device.mobile} {
      display: none;
    }
    .detail-box {
      display: flex;
      justify-content: space-between;
      gap: 50px;
      margin: 0;
      .cbt-image {
        box-sizing: border-box;
        width: 208px;
        height: 208px;
        border: 1px solid #e0e0e0;
        display: flex;
        justify-content: center;
        align-items: center;
        > img {
          width: 90%;
          height: auto;
        }
      }
      .cbt-description-wrapper {
        width: calc(100% - 258px);

        .title {
          font-size: 28px;
          font-weight: 600;
          color: #363636;
          margin: 0 0 26px;
        }

        .cbt-description-info-wrapper {
          display: flex;
          align-items: center;
          gap: 30px;
          .cbt-description-info {
            display: flex;
            align-items: center;
            gap: 7px;
            font-size: 16px;
            color: #363636;
          }
        }

        .cbt-description-box {
          height: auto;
          margin: 24px 0 40px;
          //overflow: hidden;

          .cbt-description {
            font-size: 16px;
            color: #666;
            line-height: 1.5;
            white-space: pre-wrap;
            margin: 0;

            ul {
              * {
                word-break: keep-all;
              }
              li {
                > strong {
                  font-weight: 600;
                }
              }
            }
          }
        }
      }
    }    
  }

  @media ${({ theme }) => theme.device.mobile} {
    margin-bottom: 20px;
  }
`;

const StyledMobileBuyBtn = styled.div`
  display: none;

  height: 81px;
  margin-top: 24px;

  background-color: #FAFAFA;
  padding: 16px 20px 20px 20px;

  button {
    width: 100%;
    padding: 16px 20px;    
    
    border-radius: 8px;
  }

  @media ${({ theme }) => theme.device.mobile} {
    display: block;
  }
`